import { render, staticRenderFns } from "./HeaderSaving.vue?vue&type=template&id=0b14be7c&scoped=true"
import script from "./HeaderSaving.vue?vue&type=script&lang=js"
export * from "./HeaderSaving.vue?vue&type=script&lang=js"
import style0 from "./HeaderSaving.vue?vue&type=style&index=0&id=0b14be7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b14be7c",
  null
  
)

export default component.exports